import { render, staticRenderFns } from "./OtherDocuments.vue?vue&type=template&id=18bc5d32&scoped=true"
import script from "./OtherDocuments.vue?vue&type=script&lang=js"
export * from "./OtherDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bc5d32",
  null
  
)

export default component.exports